import { AccountingClass } from "./accounting-class";
import { ChartOfAccount } from "./chart-of-account";
import { CoaTransactionSummary } from "./coa-transaction-summary";
import { Company } from "./company";
import { GeneralLedgerDetail } from "./general-ledger-detail";
import { SystemField } from "./system-field";

export class CoaTransactionDetail extends SystemField{

    coa_transaction_summary_id?:string; 
    coa_id?:string;  
    ordering?:number; 
    amount?:number;
    gl_detail_id?:string;
    credit_amount?:number;
    debit_amount?:number;
    ledger_id?:string;
    branch_id?:string;
    trans_date?:string;

    //formular fields
    begin_balance?:number;
    ending_balance?:number;

    //relationship
    coa_transaction_summary?:CoaTransactionSummary;
    chart_of_account?:ChartOfAccount;
    account_class?:AccountingClass;
    gl_details?:GeneralLedgerDetail[];
    company?:Company;
}
